import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import VueMq from "vue-mq";
import { image, priceFormat, truncate } from "./filters";

// import Buefy from "buefy";

/* import { BModal } from "buefy/dist/esm/modal";
import { BLoading } from "buefy/dist/esm/loading";
import { BMessage } from "buefy/dist/esm/message";
import { BPagination } from "buefy/dist/esm/pagination";
import { BRadioButton } from "buefy/dist/esm/radio";
import { BInput } from "buefy/dist/esm/input";
import { BField } from "buefy/dist/esm/field";
import { BSwitch } from "buefy/dist/esm/switch";
import { BDropdown, BDropdownItem } from "buefy/dist/esm/dropdown";
Vue.use(Buefy);
Vue.use(BModal);
Vue.use(BLoading);
Vue.use(BMessage);
Vue.use(BPagination);
Vue.use(BRadioButton);
Vue.use(BInput);
Vue.use(BField);
Vue.use(BSwitch);
Vue.use(BDropdown);
Vue.use(BDropdownItem);
Vue.use(Table);
 */
// https://github.com/buefy/buefy/issues/338
import {
  Modal,
  Loading,
  Message,
  Pagination,
  Radio,
  Input,
  Field,
  Switch,
  Dropdown,
  //Table,
  Tooltip,
  Button,
  Autocomplete,
  Tag,
  Toast,
  Dialog
} from "buefy";

Vue.use(Modal);
Vue.use(Loading);
Vue.use(Message);
Vue.use(Pagination);
Vue.use(Radio);
Vue.use(Input);
Vue.use(Field);
Vue.use(Switch);
Vue.use(Dropdown);
//Vue.use(Table);
Vue.use(Tooltip);
Vue.use(Button);
Vue.use(Autocomplete);
Vue.use(Tag);
Vue.use(Toast);
Vue.use(Dialog);

Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1250
  }
});

Vue.filter("image", image);
Vue.filter("truncate", truncate);
Vue.filter("priceFormat", priceFormat);

Vue.config.productionTip = false;

// https://filosophy.org/code/passing-props-to-a-root-vue-component-from-its-surrounding-html/
const mountEl = document.querySelector("#compare");

new Vue({
  store,
  render: createElement => {
    const context = {
      props: { ...mountEl.dataset }
    };
    return createElement(App, context);
  }
  // render: h => h(App)
}).$mount("#compare");
